<script setup>
import { useForm } from 'vee-validate';
import { loginSchema } from '@/validations/auth.js';
import { signInWithEmail } from '@/api/loginApi.js';
import GoogleLoginButton from '@/components/auth/GoogleLoginButton.vue';
import AuthFormLayout from './AuthFormLayout.vue';
import { useNotificationStore } from '@/stores/notification.js';
import { MESSAGES } from '@/constants/messages';

// ストアを呼び出す
const store = useNotificationStore();
// フォームバリデーション
const { handleSubmit, errors, defineField } = useForm({
  validationSchema: loginSchema,
});

const [email, emailAttrs] = defineField('email');
const [password, passwordAttrs] = defineField('password');

// バリデーション成功時のみ呼ばれる
const handleLogin = handleSubmit(async (form) => {
  try {
    await signInWithEmail(form);
    store.success(MESSAGES.INFO.LOGIN);
  } catch (error) {
    store.error(MESSAGES.ERROR.LOGIN);
    console.error(error);
  }
});
</script>
<template>
  <AuthFormLayout>
    <template #title>
      <h2 class="text-2xl pb-1">Login</h2>
    </template>

    <form
      @submit.prevent="handleLogin"
      class="p-6 md:p-10 grid grid-cols-1 md:grid-cols-[1fr_2fr] gap-y-6 md:gap-y-10 items-center"
    >
      <!-- email -->
      <label for="email" class="md:ms-auto md:w-25 md:pr-4 text-start md:text-right"> email </label>
      <div class="relative">
        <input
          v-model="email"
          v-bind="emailAttrs"
          class="w-full border rounded-sm px-2 py-1 focus:outline-offset-2 focus:outline-4"
          :class="
            errors.email
              ? 'border-red-500 focus:outline-red-400'
              : 'border-gray-500 focus:outline-emerald-400'
          "
          type="email"
          placeholder="email@xxx.com"
        />
        <p v-if="errors.email" class="absolute text-red-500 text-xs mt-1">
          {{ errors.email }}
        </p>
      </div>

      <!-- password -->
      <label for="password" class="md:ms-auto md:w-25 md:pr-4 text-start md:text-right">
        password
      </label>
      <div class="relative">
        <input
          v-model="password"
          v-bind="passwordAttrs"
          class="w-full border border-gray-500 rounded-sm px-2 py-1 focus:outline-offset-2 focus:outline-4 focus:outline-emerald-400"
          :class="
            errors.password
              ? 'border-red-500 focus:outline-red-400'
              : 'border-gray-500 focus:outline-emerald-400'
          "
          type="password"
        />
        <p v-if="errors.password" class="absolute text-red-500 text-xs mt-1">
          {{ errors.password }}
        </p>
      </div>

      <!-- button -->
      <button
        class="m-auto col-span-1 md:col-span-2 bg-emerald-500 p-2 text-white rounded-4xl cursor-pointer hover:bg-emerald-600 focus:outline-offset-2 focus:outline-4 focus:outline-emerald-400 active:bg-emerald-600 w-40 md:w-50"
        type="submit"
      >
        ログイン
      </button>
    </form>
    <template #bottom>
      <GoogleLoginButton />
    </template>
  </AuthFormLayout>
</template>
